import { render, staticRenderFns } from "./index.vue?vue&type=template&id=aaf27ec6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=aaf27ec6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf27ec6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aaf27ec6')) {
      api.createRecord('aaf27ec6', component.options)
    } else {
      api.reload('aaf27ec6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=aaf27ec6&scoped=true", function () {
      api.rerender('aaf27ec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/storeAttr/index.vue"
export default component.exports